import React, { useState, useEffect } from 'react';

// Import global CSS file
import '../interfaceSettings.css';
import TrailsMap from '../components/Trails/TrailsMap';
import { LayerGroup, LayersControl, Marker, Popup } from 'react-leaflet';
import useAxiosData from './../hooks/useAxiosData';
import Leaflet from 'leaflet';
import * as api from '../api/index';
import bench from '../assets/webp/bench.webp';
import BenchModal from '../components/Trails/BenchModal';

const Trails = () => {
    const [benches] = useAxiosData(api.fetchBenches, []);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const customIcon = new Leaflet.Icon({
        iconUrl: bench,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
    });

const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
};

/* Override react script causing accessibility issues */
useEffect(() => {
    // Fix Leaflet popup close button accessibility
    const fixPopupCloseButton = () => {
        const closeButtons = document.querySelectorAll('.leaflet-popup-close-button');
        closeButtons.forEach(button => {
            if (button.getAttribute('href') === '#close') {
                button.removeAttribute('href');
                button.style.cursor = 'pointer';
            }
        });
    };

    // Run on mount and whenever DOM updates
    const observer = new MutationObserver(fixPopupCloseButton);
    observer.observe(document.body, { childList: true, subtree: true });
    fixPopupCloseButton();

    return () => observer.disconnect();
}, []);

    return <>
        <h1>Trails Map</h1>
        <p className='lead text-center mx-4'>
            Explore our interactive trail map by selecting one of the routes below. 
            Use the bench toggle option on the bottom right of the map to show or hide important points of interest along each trail, 
            making it easier to plan your adventure.
        </p>
        <div className="container-xl d-flex justify-content-center mb-4">
            <TrailsMap userMode layerChildren={<LayersControl.Overlay name="Benches" checked>
                <LayerGroup>
                    {benches.map((bench) => (
                        <Marker key={bench._id} position={[bench.latitude, bench.longitude]} icon={customIcon}>
                            <Popup>
                                <div className="popup-container p-3">
                                    <h2 id='trail-popup-title' className="text-primary fw-bold text-center mb-2">Bench {bench.bench_number}</h2>
                                    <p className="text-muted text-center mb-3"><i className="bi bi-geo-alt"></i> {bench.location}</p>

                                    {bench.videos.length > 0 && (
                                        <div className="videos-section">
                                            <h3 id='video-popup-title' className="text-secondary fw-bold mb-2">Videos:</h3>
                                            <ul className="list-group list-group-flush">
                                                {bench.videos.map((video) => (
                                                    <li key={video._id} className="list-group-item d-flex align-items-center">
                                                        <i className="bi bi-play-circle text-primary me-2"></i>
                                                        <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-start"
                                                        aria-label={`Play video: ${video.title}`}
                                                            onClick={() => handleVideoClick(video)}
                                                        >
                                                            {video.title}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </Popup>
                        </Marker>
                    ))}
                </LayerGroup>
            </LayersControl.Overlay>} />
        </div>

        <BenchModal
    showModal={showModal}
    setShowModal={setShowModal}
    selectedVideo={selectedVideo}
/>

    </>;
};

export default Trails;
